<template>
  <div class="userAgreement">
    <div style="word-break:break-all;" v-html="userAgreement"></div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      userAgreement:''
    }
  },
  created () {
    document.title = '用户协议'
    if (this.environment.isFengChao) {
      this.$cjc.showNavigation()
    }
    this.getAppUserPrivacy()
  },
  methods: {
    async getAppUserPrivacy () {
      const { data: { result, status, msg } } = await this.$store.dispatch('getServeHallUserPrivacy', {})
      console.log(result);
      if (status === 1000) {
        this.userAgreement = result.userAgreement
      } else {
        this.$Message.error(msg)
      }
    }
  }
}
</script>

<style lang="scss">
.userAgreement {
  height: 100vh;
  padding: 20px;
}
</style>